import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const teamMembers = [
  {
    name: 'Adv. Rupam Kumari',
    role: 'Criminal & Civil Lawyer',
    image: '/rupam-photo.png'
  },
  {
    name: 'Adv. Abhyant Patel',
    role: 'Criminal & Civil Lawyer',
    image: '/abhyant-photo.png'
  }
];

const MeetTheTeam = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ color: '#1A1A1A' }}
          >
            Meet the Advocates
          </h2>
          <p 
            className="text-lg"
            style={{ color: '#555555' }}
          >
            Experienced criminal and civil lawyers practicing across India's top courts
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-white rounded border shadow-sm overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer group"
              style={{ borderColor: '#E0E0E0' }}
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-6 flex items-center justify-between">
                <div>
                  <h3 
                    className="text-xl font-bold mb-1"
                    style={{ color: '#1A1A1A' }}
                  >
                    {member.name}
                  </h3>
                  <p 
                    className="text-base"
                    style={{ color: '#555555' }}
                  >
                    {member.role}
                  </p>
                </div>
                <ArrowRight 
                  className="h-6 w-6 transition-all group-hover:translate-x-1" 
                  style={{ color: '#2B2BFF' }}
                />
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <button
            onClick={scrollToContact}
            className="text-lg font-semibold inline-flex items-center transition-all hover:gap-3 group"
            style={{ color: '#2B2BFF' }}
          >
            Contact the Team
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default MeetTheTeam;